import * as React from 'react';
import { compose, setDisplayName, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { DeviceMap, DeviceIndex } from 'types';
import { connect } from 'react-redux';
import { getDevices, isLoadingDevices } from 'selectors/deviceSelectors';
import { State } from 'reducers';
import { Select } from 'ui/shared/Select';

export type OwnProps = {
    id: string;
    cameras: ReadonlyArray<DeviceIndex>;
    value: DeviceIndex | null;
    onChange: (i: DeviceIndex) => void;
    style?: React.CSSProperties;
    disabled?: boolean;
};

const RawCameraPicker = ({
    id,
    options,
    value,
    disabled,
    handleChange,
    style,
    t,
}: OwnProps & StateProps & RecomposeProps & TranslateProps) =>
    <Select
        id={ id }
        style={ style }
        value={ typeof value === 'number' ? value : undefined }
        onChange={ handleChange }
        disabled={ disabled }
    >
        { options.map(({ name, value }) =>
            <option
                key={ value }
                value={ value }
            >
                { name }
            </option>
        ) }
    </Select>
;

type StateProps = {
    allDevices: DeviceMap;
    loading: boolean;
};
type RecomposeProps = {
    options: ReadonlyArray<{ name: string; value: string }>;
    handleChange: React.ChangeEventHandler<HTMLSelectElement>;
};

const noDevices: DeviceMap = {};

const mapStateToProps = (state: State) => ({
    allDevices: getDevices(state) || noDevices,
    loading: isLoadingDevices(state),
});

const getName = (allDevices: DeviceMap, i: DeviceIndex, notFound: string) => {
    const name = Object.keys(allDevices)
        .map(deviceId => allDevices[deviceId])
        .filter(({ deviceIndex }) => deviceIndex === i)
        .map(({ name }) => name)
        .shift() || notFound;

    return `${i}. ${name}`;
};

const makeOptions = (cameras: ReadonlyArray<DeviceIndex>, allDevices: DeviceMap, notFound: string) => {
    // Take the (unsorted) camera device indexes and look up names in allDevices
    // Return an array of { name, value } options for populating the UI (sorted by value)
    return [ ...cameras ].sort((a, b) => a - b).map(i => ({
        name: getName(allDevices, i, notFound),
        value: i.toString(),
    }));
};

export const CameraPicker = compose<OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('CameraPicker'),
    translate(),
    connect<StateProps, {}, OwnProps>(mapStateToProps),
    withProps(({ cameras, allDevices, t }: OwnProps & StateProps & TranslateProps) => ({
        options: makeOptions(cameras, allDevices, t('6.1237.3262')), // Camera not found
    })),
    withHandlers({
        handleChange: ({ onChange }: OwnProps) => (e: React.ChangeEvent<HTMLSelectElement>) => {
            const deviceIndex = parseInt(e.target.value, 10);
            onChange(deviceIndex);
        },
    }),
)(RawCameraPicker);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/line/CameraPicker.tsx